/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get */
import Controller from '@ember/controller';
import { computed } from '@ember/object';

export default class GoalsController extends Controller {
  queryParams = ['currentTab'];
  currentTab = 'Goals';

  @computed('model.subjects.@each.subjectTypeName')
  get subjectsByType() {
    let subjects = this.get('model.subjects'); // assuming 'model' is an array of subject objects

    return subjects.reduce((result, subject) => {
      let type = subject.subjectTypeName || '0';

      if (!result[type]) {
        result[type] = [];
      }
      result[type].push(subject);
      return result;
    }, {});
  }
}
